import { InjectionToken } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ISbStoriesParams, ISbStory, ISbStoryData, StoryblokBridgeV2 } from '@storyblok/js';
import { Observable } from 'rxjs';
import { StoryblokLink } from './storyblok/storyblok-types';

export interface PicflowStoryblok {
  getStories(options: ISbStoriesParams, route?: ActivatedRouteSnapshot): Observable<ISbStoryData[]>;
  components: { [key: string]: unknown };
  getStory(slug: string, route?: ActivatedRouteSnapshot): Observable<ISbStory['data'] | false>;
  loadComponents(story: ISbStoryData): Promise<void>;
  resolveRelationshipsFromStory(story: ISbStoryData, route?: ActivatedRouteSnapshot): Promise<ISbStoryData<unknown>[]>;
  updates$: Observable<{
    story: ISbStoryData;
  }>;
  getUrlLink(link: StoryblokLink): string;
  getStoryTitle(story: ISbStoryData): string;
  getStoryDescription(story: ISbStoryData): string;
  getStoryImagesToPreload(): string[];
  getUniqueComponentsList(route: ActivatedRouteSnapshot, _path?: string): Observable<Set<string>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolveRelationships(route: ActivatedRouteSnapshot, _path?: string): Observable<any[]>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getGlobalData(key: string): any;
  storyblokInstance: StoryblokBridgeV2;
}

export const PICFLOW_STORYBLOK = new InjectionToken<PicflowStoryblok>('storyblok');
